// External dependencies.
import swal from "sweetalert";
import apiFetch from "@wordpress/api-fetch";
import { __ } from "@wordpress/i18n";

/**
 * Class used to handle the wholesale form front-end.
 *
 * @since 1.4.4
 * @class WholesaleForm
 */
class WholesaleForm {
    /**
     * Creates an instance of WholesaleForm.
     * 
     * @since 1.4.4
     * @memberof WholesaleForm
     */
    constructor() {
        this.formElement = document.querySelector( '.js-wholesale-form' );
        this.submitElement = ( this.formElement ) ? this.formElement.querySelector( 'button[type="submit"]' ) : null;

        this.events = this.events.bind( this );
        this.resetSubmitElement = this.resetSubmitElement.bind( this );
        this.sendForm = this.sendForm.bind( this );
        this.handleSuccess = this.handleSuccess.bind( this );
        this.handleError = this.handleError.bind( this );

        this.events();
    }

    /**
     * Listens for events.
     *
     * @since 1.4.4
     * @listens .js-wholesale-form~event:submit
     * @memberof WholesaleForm
     */
    events() {
        this.formElement && this.formElement.addEventListener( 'submit', this.sendForm );
    }

    /**
     * Resets the submit element to its original state.
     *
     * @since 1.4.4
     * @memberof WholesaleForm
     */
    resetSubmitElement() {
        const { sendText } = this.submitElement.dataset;
        this.submitElement.removeAttribute( 'disabled' );
        this.submitElement.textContent = sendText;
    }

    /**
     * Send the form.
     *
     * @since 1.4.4
     * @param {object} e
     * @memberof WholesaleForm
     */
    async sendForm( e ) {
        e.preventDefault();

        const { sendingText } = this.submitElement.dataset;
        const url = this.formElement.getAttribute( 'action' );
        const body = new FormData( this.formElement );
        const method = 'POST';

        this.submitElement.setAttribute( 'disabled', true );
        this.submitElement.textContent = sendingText;

        try {
            const res = await apiFetch( { url, body, method } );
            this.handleSuccess( res );
        } catch ( error ) {
            this.handleError( error );
        }
    }

    /**
     * Handles the form's success action.
     *
     * @since 1.4.4
     * @param {object} res
     * @memberof WholesaleForm
     */
    handleSuccess( res ) {
        const { redirect_url } = res.data;
        window.location = redirect_url;
    }

    /**
     * Handles the form's error action.
     *
     * @since 1.4.4
     * @param {object} error
     * @memberof WholesaleForm
     */
    handleError( error ) {
        console.log( error );
        this.resetSubmitElement();
        const { name } = window.app;

        swal( {
            title: name,
            text: error.data,
            icon: 'error',
            buttons: {
                confirm: {
                    text: __( 'Aceptar', 'tio-simon-foods' ),
                    className: 'btn btn-ts-primary'
                }
            }
        } );
    }
}

export default WholesaleForm;
